import { takeLatest, put, call } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';

import * as actions from './actions';
import * as actionTypes from './actionTypes';

function* fetchDefaultClippingMedia({ payload }) {
  const { request } = payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(actions.fetchDefaultClippingMediaSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchDefaultClippingMediaFailure(error));
  }
}

export default function* saga() {
  yield takeLatest(actionTypes.FETCH_FLEETBACK_MEDIAS_CLIPPING_REQUEST, fetchDefaultClippingMedia);
}
